import React from 'react';
import { Tooltip, Button, Icon } from '@kajabi/sage-react';
import { useConfigContext, useUiResourceContext } from 'common/components/CopyMagic/contexts';
import useGeneratorTrackingCallback from 'common/components/CopyMagic/hooks/useGeneratorTrackingCallback';
import clientInfo from 'common/lib/clientInfo';
import { CHAT_EVENT_TYPES } from 'common/components/CopyMagic/constants';
import useChatSessionId from 'common/components/CopyMagic/hooks/useChatSessionId';
import postChatEvent from 'common/components/CopyMagic/api/postChatEvent';
import useChatSession from '../../hooks/useChatSession';

const buttonText = 'Open in new tab';

const FullscreenButton = () => {
  const { setOpen } = useUiResourceContext();
  const { contextToken } = useConfigContext();
  const { endChatSession } = useChatSession();
  const trackClicked = useGeneratorTrackingCallback('useTrackFullscreenClicked');
  const { getChatSessionId } = useChatSessionId();
  const userId = clientInfo.get('user_id');

  const handleClick = () => {
    window.open(`/admin/ama/chat?context_token=${contextToken}`, `kj-ama-chat-${userId}`);
    setOpen(false);
    endChatSession();
    trackClicked();
    postChatEvent({
      sessionId: getChatSessionId(),
      eventType: CHAT_EVENT_TYPES.OPENED_FULLSCREEN,
    });
  };

  return (
    <Tooltip content={buttonText} position={Tooltip.POSITIONS.LEFT}>
      <Button
        data-testid="conversation-assistant-fullscreen-button"
        color={Button.COLORS.SECONDARY}
        icon={Icon.ICONS.LAUNCH}
        iconOnly={true}
        subtle={true}
        onClick={handleClick}
      >
        {buttonText}
      </Button>
    </Tooltip>
  );
};

export default FullscreenButton;
